/* Facebook registration handler */
var fbdata = {};

(function ($) {
    $(function () {
        // reg form
        if ($(".js-registration-form").length === 0) {
            return;
        }



        $('.js-sign-up-facebook').on('click', function (e) {
            e.preventDefault();


            if ($.isEmptyObject(fbdata)) {
                FB.login(function (fbresponse) {

                    if (fbresponse.authResponse) {
                        FB.api('/me', { locale: 'en_US', fields: 'id,first_name,last_name,middle_name,email' },
                            function (response) {

                                fbdata = {
                                    'fbid': response.id,
                                    'lastname': response.last_name,
                                    'firstname': `${response.first_name} ${response.middle_name || ''}`,
                                    'email': response.email,
                                    'privacypol': 'on',
                                    'accessToken': fbresponse.authResponse.accessToken,
                                };

                                if (!$.isEmptyObject(fbdata)) {
                                    facebookReg(fbdata)
                                } else {
                                    $('.js-error-reg').text(localize.translations.fbRegError).removeClass('d-none');
                                    window.scrollTo(0, 0);
                                    setTimeout(function () {
                                        $('.js-error-reg').addClass('d-none');
                                    }, 3200);
                                }
                            });

                    }
                }, { scope: 'email' });
            }

        });

        function facebookReg(data) {
            apiGetCall('user/fbreg', data, (error, result) => {

                if (error) {
                    $('.js-error-reg').text(result.error).removeClass('d-none');
                    window.scrollTo(0, 0);
                    setTimeout(function () {
                        $('.js-error-reg').addClass('d-none');
                    }, 3200);
                }

                if (result.success === true) {
                    apiGetCall("user/fblogin", data, (error, result) => {
                        let expires = (data.remember === undefined) ? 1 : 365;

                        if (result.token) {
                            Cookies.set("token", result.token, { expires });
                            window.location.href = localize.profil_url;
                        }
                    });
                }
            });
            return false;
        }

        var blockTwice = false
        $(".js-registration-form").on('submit', function (e) {

            if (blockTwice) {
                return false;
            }

            e.preventDefault();
            $('.js-form-submit').hide();
            $('.loader').css('display', 'inline-block');

            if ($('input[name=email]').val().length < 6) {
                alert('Kérjük érvényes email címet adjon meg');
                return false;
            }

            if ($('input[name=password]').val().length < 6) {
                alert('Kérjük biztonsága érdekében legalább 6 karakteres jelszót válasszon!');
                return false;
            }

            if ($('input[name=email]').val().indexOf('@') == -1) {
                alert('Kérjük érvényes email címet adjon meg');
                return false;
            }

            if ($('input[name=password]').val() !== $('input[name=passwordAgain]').val()) {
                alert('A két jelszó nem egyezik');
                return false;
            }

            if ($('input[name=terms]:checked').length <= 0) {
                alert('Kérjük fogadja el az adatkezelési tájékoztatót!');
                return false;
            }

            if (!isCaptchaChecked()) {
                alert('Robot vagy!');
                return false;
            }

            var theForm = $(this);

            // validate data
            var data = grabFormAsObject(theForm);


            if (validateJsFormRequire(theForm, true)) {
                $('.js-form-submit').removeClass('button--disabled')
                return false;
            }

            data['validateurl'] = localize.loginurl;

            if (typeof data.remember === "undefined") {
                data.remember = false;
            }

            blockTwice = true;


            apiGetCall('user/reg', data, (error, result) => {
                blockTwice = false;

                if (error) {
                    $('.js-error-reg').text(result.error).removeClass('d-none');
                    window.scrollTo(0, 0);
                    setTimeout(function () {
                        $('.js-error-reg').addClass('d-none');
                    }, 3200);
                    return false;
                }

                if (result.success === true) {
                    window.location.href = localize.successregurl
                }
            });
            return false;


        })
    });
})(jQuery);